<span
  class="inline-flex items-center justify-center rounded-full bg-gray-400"
  [ngClass]="'icon-size-' + iconSize"
>
  <span class="text-sm font-medium leading-none text-white"> {{ text }} </span>
</span>
